
import { Authentication } from './stores'
import { notifications } from './notifications.js'

export async function delCustomer(customer) {

  let authenthicationData = '';
  console.log('In customerStore: ' + customer.id);

  await Authentication.subscribe((data) => authenthicationData = data);

  const response = await fetch(
      'MYURL/Customer/Del',
      {
          method: 'POST',
          headers: {
              'Content-type': 'application/json',
              'Authorization': authenthicationData
          },
          body: JSON.stringify(
              customer
          )
      }
  );

  if (!response.ok) {
    notifications.danger('Error!', 500);
  }
  const data = await response.json();
  
}
